<template>
    <div class="container" v-if="bShowPage" :style="{'height':bBackList?'100vh':'','overflow':bBackList?'hidden':''}">
        <div class="search-column">
            <div class="search-left">
                <p>全国案例：</p>
                <p>
                    <span>{{ oTotalNum.total }}</span>户
                </p>
            </div>
            <div class="search-right">
                <div class="search" @click="showSearchModal()">
                    <span>按条件搜索</span>
                    <div :class="['serch-icon', bSearchModalShow ? '' : 'down']"></div>
                </div>
                <div class="area" @click="openCityPicker()">
                    <span>{{ oPositionInfo.city }}</span>
                    <div class="area-icon"></div>
                </div>
                <div class="map" v-show="!isMapShow" @click="mapToCaseChange()">
                    <span>地图</span>
                    <div class="map-icon"></div>
                </div>
                <div class="list" v-show="isMapShow" @click="mapToCaseChange()">
                    <span>列表</span>
                    <div class="list-icon"></div>
                </div>
            </div>
        </div>
        <div class="tips" v-if="bTips">
            <div class="tips_warp">
                <div class="tips_title">温馨提示!</div>
                <div>您未开启手机定位,请选择城市</div>
            </div>
        </div>
        <div class="box-null"></div>

        <!-- 全部案例 -->
        <all-case ref="allCase" v-show="!isMapShow" :isAll.sync="isAll" :nHeight="nHeight"
                  :bSearchModalShow.sync="bSearchModalShow" :nCityId="oPositionInfo.cityId"
                  :nLng="oPositionInfo.longitude" :nLat="oPositionInfo.latitude" :nCity="nCity"
                  @closeSchMark="closeSchMark"/>

        <!-- 地图 -->
        <ant-map ref="antMap" v-show="isMapShow" :arrNav="arrNav" :oTotalNum="oTotalNum" :longitude="nLongitude"
                 :latitude="nLatitude" @openToast="openToast"/>

        <!-- 搜索弹窗 -->
        <!-- <search-modal :bSearchModalShow.sync="bSearchModalShow"/> -->

        <!-- 地址选择 -->
        <awesome-picker ref="picker" :data="arrCityList" :colorConfirm="oPicker.colorConfirm"
                        @confirm="confirmCity"></awesome-picker>
        <!-- 黑名单遮罩层 -->
        <div class="mengceng" v-if="bBackList">
            <div class="mengceng_tips">
                <div class="mengceng_title">温馨提示!</div>
                <div class="mengceng_text">
                    您已经被列入黑名单!
                </div>
            </div>
        </div>
        <!--通知icon-->
        <div class="tips-icon" @click="toListTips" v-if="bShowTips">
            <img src="@/assets/images/antV2/tips2.png" alt="">
            <span class="tips-num" v-if="nTipsNum">{{ nTipsNum > 99 ? '99+' : nTipsNum }}</span>
        </div>
        <!-- 返回按钮-->
        <img src="@/assets/images/antV2/back-icon02.png" v-if="isShowBack" class="back-icon" @click="toBack" alt="">
    </div>
</template>

<script>
import searchModal from "./components/searchModal/index.vue";
import antMap from "./components/map/index.vue";
import allCase from "./components/allCase/index.vue";
import oForm from "@/js/form.js";
import oDetail from "@/js/detail.js";
import {Toast} from "mint-ui";
import {getProjectTotalNum, getProjectTotalNumV2} from "@/js/map.js";
import {getWxSingleConfig, wxGetLocationH5, geoGetLocation} from "@/js/wx.js";
import {readNum} from "@/js/project/share";

export default {
    name: "caseMap_useKP",
    components: {
        searchModal,
        antMap,
        allCase,
    },
    data() {
        return {
            bShowTips: false,
            nTipsNum: 0,
            isShowBack: false,//只有分享详情点击跳转才显示返回按钮
            bBackList: false,
            bTips: false,
            isMapShow: false, // 地图显示
            bSearchModalShow: false, // 全部案例显示

            nLongitude: null, // 经度
            nLatitude: null, //纬度
            nCity: "", //用来对比接口返回的数据是否是同一个城市
            oTotalNum: {}, // 获取全国数量
            oPositionInfo: {
                province: null,
                provinceId: null,
            },
            isAll: 1,
            bShowPage: false, // 页面加载完显示
            arrNav: [],
            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)",
            }, // 三级联动弹窗配置
            arrTreelist: [],
            arrCityList: [], // 三级联动城市列表
            nHeight: {}, ///记录浏览器滚动高度
            tCensus: '', // 定时器
        };
    },
    activated() {
        if (this.$route.query.antform != undefined) {
            this.$storage.setStorage("antMap", 2);
            //  console.log("已被keep缓存");
            // debugger
        }
        let nHeight = this.$store.state.sorllHeight;
        if (nHeight) {
            this.nHeight = nHeight;
        }
        this.getTipsNum()
        //  console.log("---->aaa", nHeight);
    },
    computed: {},
    created() {
        //23-5-31 项目3.0上线，老版本的项目案例入口重定向到3.0
        this.$router.replace('/project/v3/case/index');
        return

        this.$store.commit("loadSwitch", true);
        this.getInfo()
        if (this.$route.query.isShareInfo) {
            this.isShowBack = true
        }
        if (this.$route.query.project_uuid) {
            this.addReadNum(this.$route.query.project_uuid, 'case', 'dis_more').then(res => {
                this.$store.commit('loadSwitch', false)
                this.tCensus = setInterval(() => {
                    console.log('统计数据---更多案例')
                    // this.$toast('统计')
                    this.addReadNum(this.$route.query.project_uuid, 'case', 'dis_more', res)
                }, 5000)
            })
        }
        //  console.log(window.location.search, "地址栏--------------------");
        let param = window.location.search;
        //携带参数进来. 解码并请求
        if (param) {
            this.sbmitRecord(param);
        }
        //  paras = paras.join("?")
        //  console.log(paras);
        let that = this;
        that.$storage.removeStorage("empinfo");
        this.getBlackList();
        this.$store.commit("loadSwitch", true);
        // this.getTipsNum()
        this.getTree(() => {
            console.log('完成了')
            // 获取微信签名，获取地理位置
            let confit = {
                share_friend_title:
                    "A.O.史密斯AI-LiNK冷暖风水专业集成-项目案例",
                share_friend_desc: "中央空调·采暖·新风·全屋用水",
                share_img_url:
                    "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/share_two_img.png",
                share_link: window.location.href,
            };
            getWxSingleConfig(confit).then(res => {
                this.$store.commit("loadSwitch", false);
                setTimeout(() => {
                    wxGetLocationH5()
                        .then((addresInfo) => {
                            this.oPositionInfo = addresInfo;
                            this.oPositionInfo.city =
                                addresInfo.city || addresInfo.province;
                            this.oPositionInfo.provinceId =
                                that.arrTreelist[0].filter((item) =>
                                    item.name.includes(
                                        this.oPositionInfo.province.substring(0, 2)
                                    )
                                )[0].id || null;
                            this.oPositionInfo.cityId =
                                that.arrTreelist[
                                    this.oPositionInfo.provinceId
                                    ].filter((item) =>
                                    item.name.includes(
                                        this.oPositionInfo.city.substring(0, 2)
                                    )
                                )[0].id || null;
                            that.getProjectTotalNum();
                            this.$store.commit("loadSwitch", false);
                            this.bShowPage = true;
                            this.bTips = false;
                        })
                        .catch(() => {
                            this.bShowPage = true;
                            this.bTips = true;
                            setTimeout((res) => {
                                this.oPositionInfo = {};
                                this.oPositionInfo.city = "未选择";
                                this.$store.commit("loadSwitch", false);
                                this.bTips = false;
                                this.$refs.picker.show();
                            }, 700);
                        });
                }, 200)
            });
        });
    },
    mounted() {
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.tCensus)
        console.log('清楚统计数据')
        this.tCensus = ''
        next()
    },
    methods: {
        getTipsNum() {
            oDetail.getTipsNum().then(res => {
                console.log(res, '请求结果222')
                this.nTipsNum = res.result.num
                console.log(this.nTipsNum, 'nTipsNum')
            })
        },
        // 统计阅读量
        addReadNum(uuid, type, notice_type, log_id) {
            return new Promise(resolve => {
                //todo 正式先不上统计
                let options = {
                    project_uuid: uuid,
                    type: type,
                    notice_type,
                }
                if (log_id) {
                    options.log_id = log_id
                }
                readNum(options, false).then(res => {
                    resolve(res.data.result)
                })
            })
        },
        getInfo() {
            oDetail.getAuthorZxy().then((res) => {
                console.log(res, '测试')
                this.bShowTips = res.result
            });
        },
        // 返回上一页
        toBack() {
            this.$router.back()
        },
        // 跳转通知列表
        toListTips() {
            this.$router.push('/project/antMap/tips')
        },
        // 黑名单
        getBlackList() {
            let _that = this;
            _that.ambient().then((i) => {
                let obj = {
                    platform: i,
                };
                if (this.$route.query.qywxUserId) {
                    obj.user_id = this.$route.query.qywxUserId;
                }
                oDetail.getBlackList2(obj).then((res) => {
                    if (res.result.constructor != Array) {
                        _that.bBackList = true;
                    }
                });
            });
        },
        // 判断当前是什么环境
        ambient() {
            return new Promise((resolve, reject) => {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    if (ua.match(/WxWork/i) == "wxwork") {
                        if (wx?.miniProgram?.getEnv) {
                            wx.miniProgram.getEnv(function (res) {
                                if (res.miniprogram) {
                                    // 小程序环境下逻辑
                                    resolve(1);
                                } else {
                                    //非小程序环境下逻辑
                                    resolve(2);
                                }
                            });
                        } else {
                            //企业微信环境下
                            resolve(2);
                        }
                    } else {
                        //判断是否是微信环境
                        //微信环境
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                resolve(1);
                            } else {
                                //非小程序环境下逻辑
                                resolve(3);
                            }
                        });
                    }
                } else {
                    // 非微信环境逻辑
                    resolve(2);
                }
            });
        },
        // 打开城市选择
        openCityPicker() {
            this.$refs.picker.show();
        },
        // 选择城市
        confirmCity(res) {
            //  console.log("选择城市", res);
            let select = res;
            const that = this;
            this.$store.commit("loadSwitch", true);
            geoGetLocation(res[0].value + res[1].value)
                .then((result) => {
                    //  console.log(result.geocodes[0].location);

                    that.oPositionInfo.city = res[1].value;
                    that.oPositionInfo.cityId =
                        that.arrCityList[res[0].index].children[
                            res[1].index
                            ].id;

                    (that.nCity = that.oPositionInfo.city),
                        (that.oPositionInfo.longitude =
                            result.geocodes[0].location.lng);
                    that.oPositionInfo.latitude =
                        result.geocodes[0].location.lat;
                    if (that.isMapShow) {
                        that.nLongitude = that.oPositionInfo.longitude;
                        that.nLatitude = that.oPositionInfo.latitude;
                    }
                    // 获取案例总数
                    that.getProjectTotalNum();

                    that.$store.commit("loadSwitch", false);

                    // 获取对应省市的案例列表
                    that.$refs.allCase.getProjectList2({
                        nCityId: that.oPositionInfo.cityId,
                        nLng: this.oPositionInfo.longitude,
                        nLat: this.oPositionInfo.latitude,
                    });
                })
                .catch((err) => {
                    Toast({
                        message: "无案例数据！",
                        position: "bottom",
                        duration: 1200,
                    });
                    //  console.log(err, "err");
                    that.$store.commit("loadSwitch", false);
                });
        },
        // 地图和全部案例切换
        mapToCaseChange() {
            if (this.isMapShow) {
                this.isMapShow = false;
            } else {
                this.nLongitude = this.oPositionInfo.longitude;
                this.nLatitude = this.oPositionInfo.latitude;
                this.isMapShow = true;
            }
        },
        // 开启搜索弹窗
        showSearchModal() {
            if (this.isMapShow && this.bSearchModalShow) {
                this.isMapShow = false;
                return false;
            }
            this.isMapShow = false;
            this.bSearchModalShow = !this.bSearchModalShow;
        },
        // 获取地址三级联动数据
        getTree(callback) {
            oForm.getTree().then((res) => {
                let arrTree = res.data.data.result;
                this.arrTreelist = arrTree;
                let arrProvince = arrTree[0];
                arrProvince.forEach((it) => {
                    it["value"] = it.name;
                    if (arrTree[it.id].length) {
                        it["children"] = arrTree[it.id];
                        it.children.forEach((sit) => {
                            sit["value"] = sit.name;
                            // sit['children'] = arrTree[sit.id]
                        });
                    }
                });
                arrProvince.splice(0, 1);
                this.arrCityList = arrProvince;
                callback && callback();
            });
        },
        // 获取全国数量
        async getProjectTotalNum() {
            // getProjectTotalNumV2  getProjectTotalNum  两个版本
            const resultData = await getProjectTotalNumV2({
                city_id: this.oPositionInfo.cityId,
            });
            this.arrNav = [
                {
                    className: "active-1",
                    iconName: "nav-icon-1",
                    id: 1,
                    open: false,
                    name: "已签约",
                    oTotalNum: resultData.data.data.result.sign_num,
                },
                {
                    className: "active-2",
                    iconName: "nav-icon-2",
                    id: 2,
                    open: false,
                    name: "施工中",
                    oTotalNum: resultData.data.data.result.build_num,
                },
                {
                    className: "active-3",
                    iconName: "nav-icon-3",
                    id: 3,
                    open: false,
                    name: "已完工",
                    oTotalNum: resultData.data.data.result.finish_num,
                },
            ];
            this.oTotalNum = resultData.data.data.result;
            //  console.log(this.oTotalNum, "-----------");
        },
        closeSchMark() {
            //关闭搜索弹窗
            this.isAll = 0;
        },
        openToast() {
            //打开弹窗
            this.$refs.picker.show();
        },
        sbmitRecord(url) {
            //截取地址栏数据
            const obj = {};
            var str = url.substring(1);
            //如果存在&符号，则再以&符号进行分割
            var arr = str.split("&");
            //遍历数组
            for (var i = 0; i < arr.length; i++) {
                obj[arr[i].split("=")[0]] = unescape(arr[i].split("=")[1]);
            }
            //  console.log(obj);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
